export default class Calendar {
    constructor(element) {
        this.element = element;
        this.calendarEl = this.element.querySelector('#calendar');
        this.evenement = this.element.querySelectorAll('.event');
        this.filterLieu = this.element.querySelector('.js-filter-lieu');

        this.events = [];
        this.calendarInstance = null;

        this.init();
    }

    init() {
        if (!this.calendarEl) return;

        this.populateEvents();

        this.calendarInstance = new FullCalendar.Calendar(this.calendarEl, {
            initialView: window.innerWidth < 768 ? 'listWeek' : 'dayGridMonth',
            locale: 'fr',
            noEventsContent: "Aucun événement trouvé",
            height: 'auto',
            events: this.events,

            windowResize: function(arg) {
                const cal = arg.view.calendar;
                const newView = window.innerWidth < 768 ? 'listWeek' : 'dayGridMonth';

                if (cal.view.type !== newView) {
                    cal.changeView(newView);
                    cal.updateSize();
                }
            }
        });

        this.calendarInstance.render();
        this.bindFilters();

        //console.log('filter select:', this.filterLieu);
        //console.log('events loaded:', this.events);
    }

    populateEvents() {
        this.events = [];

        for (let i = 0; i < this.evenement.length; i++) {
            const element = this.evenement[i];

            this.events.push({
                title: element.dataset.title,
                start: element.dataset.time,
                url: element.dataset.url,
                extendedProps: {
                    lieuId: element.dataset.lieuId,
                    lieu: element.dataset.lieu
                }
            });
        }
    }

    bindFilters() {
        if (!this.filterLieu) return;

        this.filterLieu.addEventListener('change', () => {
            console.log('selected lieu:', this.filterLieu.value);
            this.applyFilters();
        });
    }

    applyFilters() {
        const selectedLieu = this.filterLieu ? this.filterLieu.value : '';

        const filteredEvents = this.events.filter((event) => {
            if (!selectedLieu) return true;
            return event.extendedProps.lieuId == selectedLieu;
        });

        console.log('filtered events:', filteredEvents);

        this.calendarInstance.removeAllEvents();
        this.calendarInstance.addEventSource(filteredEvents);
    }
}